import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import AlertView from "./alert";
import MessageModel from "../../models/alert-message";

const channel = Radio.channel("global");

class View extends Marionette.LayoutView {
  el() {
    return "body";
  }

  regions() {
    return {
      container: "#status",
    };
  }

  initialize() {
    channel.on("status:show", this._onShow, this);
  }

  _onShow(options) {
    const model = new MessageModel(options);

    // validate it
    if (model.isValid()) {
      // display it
      this.container.show(
        new AlertView({
          model,
        })
      );
    } else {
      // warning to console
      console.warn(
        "Alert message could not be displayed. %s",
        this.model.validationError
      );
    }
  }
}

export { View as default };
